import { cn } from '@lyearn/style';
import { Stack } from '@lyearn/ui';

import devicesConfig from '../../devices-config';
import { DeviceSwitcherProps } from '../../types';
import DeviceButton from './DeviceButton';

const DeviceSwitcher: React.VFC<DeviceSwitcherProps> = ({
  selectedDevice,
  setSelectDevice,
  enabledDevices = [],
  classNames,
}) => {
  const devices = enabledDevices.length
    ? devicesConfig.filter((device) => enabledDevices.includes(device.id))
    : devicesConfig;

  return (
    <Stack className={cn('space-s-8', classNames)}>
      {devices.map((device, index) => (
        <DeviceButton
          key={device.id}
          device={device}
          selected={selectedDevice ? device.id === selectedDevice : index === 0}
          onSelect={setSelectDevice}
        />
      ))}
    </Stack>
  );
};

export default DeviceSwitcher;
